module.exports = __webpack_public_path__ + "static/img/settingError.417fe0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/settingError.png
// module id = 3Sgl
// module chunks = 2